
// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class BlocksBrokenNotification extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // circle_white_large_png
    const circle_white_large_png = scene.add.image(0, 0, "game-tiles", "smashbar-star-blue.png");
    this.add(circle_white_large_png);

    /* START-USER-CTR-CODE */
    this.startScale = this.scale;
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */
  private startScale:number;

  public show(targetX:number, targetY:number)
  {
    this.visible = true;
    this.scale = this.startScale;

    let tween = this.scene.add.tween({
      targets: this,
      x:targetX,
      y:targetY,
      scale:this.startScale/2,
      duration: 500,
      ease: "Quad.InOut"
    });

    tween.on("complete",()=>{
      this.visible = false;
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
